import { render, staticRenderFns } from "./RouteNav.vue?vue&type=template&id=4ffd5c70&scoped=true&"
import script from "./RouteNav.vue?vue&type=script&lang=js&"
export * from "./RouteNav.vue?vue&type=script&lang=js&"
import style0 from "./RouteNav.vue?vue&type=style&index=0&id=4ffd5c70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd5c70",
  null
  
)

export default component.exports